import { render, staticRenderFns } from "./QuoteBuilderSidebar.vue?vue&type=template&id=5392bf46&scoped=true"
import script from "./QuoteBuilderSidebar.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderSidebar.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderSidebar.vue?vue&type=style&index=0&id=5392bf46&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5392bf46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5392bf46')) {
      api.createRecord('5392bf46', component.options)
    } else {
      api.reload('5392bf46', component.options)
    }
    module.hot.accept("./QuoteBuilderSidebar.vue?vue&type=template&id=5392bf46&scoped=true", function () {
      api.rerender('5392bf46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuoteBuilderSidebar.vue"
export default component.exports